import {
  makeStyles,
  useTheme,
  useMediaQuery,
  Container,
} from '@material-ui/core'
import { useTranslation } from 'next-i18next'
import CarouselSp2 from '../ui/CarouselSp2'

const customers = [
  ['beauticool.png', 'Beauticool'],
  ['srichand.png', 'Srichand'],
  ['beauty-nista.png', 'Beauty Nista'],
  ['moomall.png', 'Moomall'],
  ['popteen.png', 'Popteen'],
  ['lotus.png', 'Lotus Bedding'],
  ['catcha.png', 'Catcha'],
  ['lotus-mattress.png', 'Lotus Mattress'],
  ['proplugin.png', 'Pro Plugin'],
  ['shoplus.png', 'Shoplus'],
].map((list) => ({ img: list[0], label: list[1] }))

const useStyles = makeStyles((theme) => ({
  root: {
    ...theme.homeStyle.section,
    paddingLeft: 0,
    paddingRight: 0,
  },
  customer: {
    height: 120,
    padding: theme.spacing(2),
    '& img': {
      maxWidth: '100%',
      maxHeight: '100%',
    },
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  title: {
    ...theme.homeStyle.title,
  },
}))

const OurCustomers = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const isTabletOrMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const classes = useStyles()

  const { t } = useTranslation('for-developers')

  return (
    <div className={classes.root}>
      <h1 className={classes.title}>{t('customer-example')}</h1>
      <Container style={{ padding: 0 }}>
        <CarouselSp2
          slidesPerPage={isMobile ? 2 : isTabletOrMobile ? 3.5 : 5}
          showArrows={!isTabletOrMobile}
          showDots={isTabletOrMobile && !isMobile}
          notCentered={!isMobile}
          autoPlay
        >
          {customers.map((customer) => (
            <div className={classes.customer} key={customer.label}>
              <img
                src={`/static/img/for-developers/api-partner/${customer.img}`}
                alt={customer.label}
              />
            </div>
          ))}
        </CarouselSp2>
      </Container>
    </div>
  )
}

export default OurCustomers
